export default {
  title: "Related Orders",
  title_placeholder_empty: "There aren’t grouped orders",
  subtitle_placeholder_empty: "All grouped orders will be shown here",
  title_related_placeholder_empty: "There aren’t related orders",
  subtitle_related_placeholder_empty: "All related orders will be shown here",
  grouped: "Grouped",
  related: "Related",
};
